export default __webpack_public_path__ + "static/media/HeroMontage.463eff61.jpg";